const S3_BASE_URL = 'https://tcg-public.s3.sa-east-1.amazonaws.com/dev/survey-images/';

export const generateVideoUrl = (videoPath) => {
  if (!videoPath) return null;

  // Si ya es una URL completa, devolverla tal como está
  if (videoPath.startsWith('http')) {
    return videoPath;
  }

  // Codificar caracteres especiales en la URL
  const encodedPath = encodeURIComponent(videoPath).replace(/%2F/g, '/');

  return `${S3_BASE_URL}${encodedPath}`;
};

export default generateVideoUrl;
